<template>
  <dn-button
    v-if="showLoadMore"
    class="dn-load-more outline"
    :text="t('Load more')"
    :disable="loading"
    @click="loadMoreItems"
  />
</template>
<script lang="ts" setup>
const { t } = useI18n();
const props = defineProps({
  cid: {
    type: String,
    required: true
  },
  size: {
    type: Number,
    required: false,
    default: 10
  },
  total: {
    type: Number,
    required: false,
    default: 0
  }
});

const offset = ref(0);
const size = ref(props.size);
const loading = inject('loading', ref(false));

const loadMoreItems = () => {
  offset.value += props.size;
  useBusEmitter(`collection__options__${props.cid}`, {
    hits: size.value,
    offset: offset.value
  });
};

const showLoadMore = computed(() => {
  return props.total > offset.value + size.value;
});

let listenerCleanup: (() => void) | null = null;

onMounted(() => {
  listenerCleanup = useBusListener({
    [`collection__options__${props.cid}`]: (data: any) => {
      if (data.offset !== undefined && data.offset === 0) {
        offset.value = 0;
      }
    }
  });
});

onUnmounted(() => {
  listenerCleanup?.();
});

</script>

<style lang="scss">
button {
  &.outline {
    &.dn-load-more {
      --dn_font-size: var(--typography-utility-button-font-size, 14px);
      --dn_color: var(--color-button-secondary-default-fg);

      padding: var(--ui-gap) var(--row-gap);
      margin: 0 auto;
    }
  }
}
</style>
